import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import PageContainer from "~/components/PageContainer";
import Login from "~/pages/Auth/Login";
import PageId from "~/utils/PageId";

export const Route = createFileRoute("/callback")({
  staticData: {
    pageId: PageId.AUTH_CALLBACK,
    titleKey: "pageTitles.authCallback",
    hideNav: true,
  },
  component: CallbackRoute,
});

function CallbackRoute() {
  const { t } = useTranslation("common");
  return (
    <PageContainer title={t("pageTitles.authCallback")} hideNav>
      <Login isCallback />
    </PageContainer>
  );
}
